module.exports = __webpack_public_path__ + "static/media/btnapplestore.d487188d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/btnapplestore.png
// module id = 492
// module chunks = 0